import React from 'react';
import Icon from '../../../components/AppIcon';

const UserTableHeader = ({ allSelected, onSelectAll, sortBy, sortOrder, onSort }) => {
  const columns = [
    { key: 'name', label: 'Utilisateur', sortable: true },
    { key: 'role', label: 'Rôle', sortable: true },
    { key: 'status', label: 'Statut', sortable: true },
    { key: 'lastLogin', label: 'Dernière connexion', sortable: true },
    { key: 'createdAt', label: 'Date de création', sortable: true },
    { key: 'actions', label: 'Actions', sortable: false }
  ];

  const handleSort = (key) => {
    if (sortBy === key) {
      onSort(key, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(key, 'asc');
    }
  };

  const getSortIcon = (columnKey) => {
    if (sortBy !== columnKey) {
      return <Icon name="ChevronsUpDown" size={14} className="text-muted-foreground/50" />;
    }
    return sortOrder === 'asc' 
      ? <Icon name="ChevronUp" size={14} className="text-primary" />
      : <Icon name="ChevronDown" size={14} className="text-primary" />;
  };

  return (
    <thead className="bg-muted/50 border-b border-border">
      <tr>
        <th className="px-4 py-3 text-left w-12">
          <div className="flex items-center justify-center">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={(e) => onSelectAll(e?.target?.checked)}
              className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2 cursor-pointer"
              title="Sélectionner tout"
            />
          </div>
        </th>
        {columns?.map((column) => (
          <th
            key={column?.key}
            className="px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider"
          >
            {column?.sortable ? (
              <button
                onClick={() => handleSort(column?.key)}
                className="flex items-center gap-2 hover:text-foreground transition-colors duration-200 group"
                type="button"
              >
                <span>{column?.label}</span>
                {getSortIcon(column?.key)}
              </button>
            ) : (
              <span>{column?.label}</span>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default UserTableHeader;